import { IAgenda, Transcription } from "../interfaces/home/IMainContainer";

export const isAgenda = (item: Transcription): item is IAgenda =>
  item?.type === "agenda";
